{
    "locale": "sr-RS",
    "General": {
        "OrText": "Ili",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Idi na My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Kreiraj novi nalog",
        "ButtonText_SignInToYourAccount": "Prijavi se na svoj nalog",
        "ButtonText_StartInterviewWithoutSigningUp": "Pokreni intervju bez registracije",
        "ButtonText_StartInterviewWithoutSigningIn": "Pokreni intervju bez prijave",
        "Navlink_Dashboard": "Početna",
        "Navlink_MyInterviews": "Moji intervjui",
        "Navlink_LearnWithHubert": "Uči uz Hubert",
        "Navlink_HelpCenter": "Centar za pomoć",
        "MyProfile": "Moj profil",
        "LogOut": "Odjavi se"
    },
    "Login": {
        "MainTitle": "Pogledaj rezultate svog Hubert intervjua",
        "Subtitle": "Prijavi se da vidiš rezultate, dobiješ povratne informacije, pročitaš savete i još mnogo toga.",
        "LoginTitle": "Prijavi se na svoj Hubert nalog",
        "Label_Email": "Imejl",
        "Label_Password": "Lozinka",
        "ButtonText_SignIn": "Prijavi se",
        "ButtonText_ForgotPassword": "Zaboravljena lozinka?",
        "ButtonText_ContinueWithGoogle": "Nastavi uz Google",
        "OrSeparator": "Ili",
        "Error_Email_Required": "Imejl je obavezan.",
        "Error_Email_Invalid": "Unesi ispravnu imejl adresu.",
        "Error_Password_Required": "Lozinka je obavezna.",
        "Error_Use_Same_Email_As_Interview": "Molimo te da koristiš istu imejl adresu kao na intervjuu."
    },
    "Registration": {
        "MainTitle": "Pogledaj rezultate svog Hubert intervjua",
        "Subtitle": "Registruj se da vidiš rezultate, dobiješ povratne informacije, pročitaš savete i još mnogo toga.",
        "RegistrationTitle": "Kreiraj Hubert nalog",
        "BenefitsBox_Title": "Možeš da",
        "BenefitsBox_Point1": "pristupiš istoriji svojih intervjua",
        "BenefitsBox_Point2": "dobiješ povratne informacije o intervjuima",
        "BenefitsBox_Point3": "ponovo iskoristiš odgovore u novim intervjuima",
        "BenefitsBox_Point4": "dobiješ savete za intervju",
        "BenefitsBox_Point5": "pročitaš vodiče za karijeru",
        "BenefitsBox_Point6": "i još mnogo toga",
        "Label_FirstName": "Ime",
        "Label_LastName": "Prezime",
        "Label_Email": "Imejl",
        "Label_Password": "Lozinka",
        "Label_PhoneNumber": "Broj telefona",
        "Label_TermsOfService": "Prihvatam",
        "Label_TermsOfServiceLink": "Politiku privatnosti i Uslove korišćenja",
        "Placeholder_CountryCode": "Izaberi pozivni broj države",
        "Placeholder_PhoneNumber": "Npr. 07700900000",
        "HelpText_Password": "Lozinka treba da ima najmanje 6 karaktera.",
        "ButtonText_SignUp": "Registruj se",
        "ButtonText_SignUpWithGoogle": "Registruj se uz Google",
        "OrSeparator": "Ili",
        "Error_FirstName_Required": "Ime je obavezno.",
        "Error_LastName_Required": "Prezime je obavezno.",
        "Error_Email_Required": "Imejl je obavezan.",
        "Error_Email_Invalid": "Unesi ispravnu imejl adresu.",
        "Error_Email_Exists": "Ova imejl adresa je već zauzeta.",
        "Error_Password_Required": "Lozinka je obavezna.",
        "Error_Password_6_Characters": "Lozinka mora da ima najmanje 6 karaktera.",
        "Error_PhoneNumber_Required": "Broj telefona je obavezan.",
        "Error_PhoneNumber_Invalid": "Broj telefona nije ispravan.",
        "Error_PrivacyPolicyCheck_Required": "Moraš da prihvatiš Politiku privatnosti i Uslove korišćenja."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Da bi nastavio na intervju, potrebno je da prihvatiš uslove korišćenja Huberta. Samo označi polje da nastaviš.",
        "Subtitle_AfterInterviewCompleted": "Registruj se da vidiš rezultate, dobiješ povratne informacije, pročitaš savete i još mnogo toga.",
        "PrivacyPolicyText": "Pritiskom na „Registruj se“ prihvataš",
        "PrivacyPolicyLink": " Politiku privatnosti i Uslove korišćenja",
        "ButtonText_SignUp": "Registruj se i idi na intervju",
        "ButtonText_SignUpNormal": "Registruj se",
        "ButtonText_SignInInstead": "Klikni ovde da se prijaviš"
    },
    "LoginInviteEmail": {
        "Subtitle": "Prijavi se da vidiš rezultate, dobiješ povratne informacije, pročitaš savete i još mnogo toga."
    },
    "AppMessages": {
        "internal-server-error": "Došlo je do neočekivane greške.",
        "invalid-credentials": "Podaci za prijavu nisu ispravni. Pokušaj ponovo.",
        "user-not-found": "Podaci za prijavu nisu ispravni. Pokušaj ponovo.",
        "account-not-found": "Nalog nije ispravan. Pokušaj ponovo.",
        "verify-email-title": "Potvrdi svoju imejl adresu",
        "verify-email-subtitle": "Proveri imejl da potvrdiš svoj nalog.",
        "email-not-verified-title": "Imejl nije potvrđen",
        "email-not-verified-subtitle": "Proveri imejl da potvrdiš svoj nalog.",
        "verifying-email-title": "Potvrđujemo imejl",
        "verifying-email-subtitle": "Sačekaj...",
        "sign-in-title": "Prijavljivanje",
        "sign-in-subtitle": "Sačekaj...",
        "server-error": "Nešto je pošlo po zlu.",
        "hubert-user-exists": "Nalog već postoji.",
        "account-exists": "Nalog već postoji.",
        "email-verified": "Tvoja imejl adresa je potvrđena.",
        "email-is-taken": "Ova imejl adresa je već zauzeta.",
        "re-enter-password": "Za prijavu koristi lozinku",
        "password-reset": "Tvoja lozinka je promenjena.",
        "re-enter-new-password": "Za prijavu koristi novu lozinku",
        "invalid-invitation": "Pozivnica nije ispravna.",
        "invalid-code": "Kod za potvrdu nije ispravan.",
        "email-already-verified": "Imejl adresa je već potvrđena.",
        "email-mismatch-title": "Imejl adrese se ne poklapaju",
        "email-mismatch-subtitle": "Molimo te da koristiš istu imejl adresu kao prilikom prijave za posao."
    },
    "TransitionPage": {
        "loading-title": "Učitavanje...",
        "loading-subtitle": "Pripremamo tvoje podatke...",
        "logout-title": "Učitavanje...",
        "logout-subtitle": "Odjavljujemo te..."
    },
    "ImpersonationPage": {
        "loading-title": "Učitavanje...",
        "loading-subtitle": "Pripremamo tvoje podatke..."
    },
    "ProcessInvitation": {
        "loading-title": "Učitavanje...",
        "loading-subtitle": "Sačekaj dok učitamo tvoj intervju.",
        "InvitationNotFound": "Ne možemo da pronađemo tvoj intervju.",
        "InvitationExpired": "Ovaj link za pristup intervjuu je istekao.",
        "InvitationExpired_Description1": "Otvori intervju iz",
        "InvitationExpired_Description2": "ili kontaktiraj svog regrutera.",
        "InvitationInvalid": "Link za ovu pozivnicu nije ispravan.",
        "InterviewCompleted": "Ovaj intervju je već završen."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Moji intervjui",
            "TableHead_Employer": "Poslodavac",
            "TableHead_Job": "Pozicija",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Datum prijave",
            "TableBody_StartInterview": "Intervju nije završen. Klikni ovde da ga pokreneš ili nastaviš.",
            "TableBody_NotScored": "Intervju je završen. Rezultati će uskoro biti dostupni.",
            "TableBody_Details": "Klikni ovde da vidiš rezultate intervjua i još mnogo toga.",
            "ApplicationDate_Invited": "Pozivnica poslata",
            "ApplicationDate_MinuteAgo": "pre jednog minuta",
            "ApplicationDate_MinutesAgo": "pre nekoliko minuta",
            "ApplicationDate_HourAgo": "pre jednog sata",
            "ApplicationDate_HoursAgo": "pre nekoliko sati",
            "ApplicationDate_DayAgo": "pre jednog dana",
            "ApplicationDate_DaysAgo": "pre nekoliko dana",
            "ButtonText_SeeAllInterviews": "Pogledaj sve intervjue",
            "ButtonText_Details": "Detalji",
            "ButtonText_StartInterview": "Idi na intervju",
            "ButtonText_NotScored": "Rezultati uskoro",
            "NoInterviews_Message": "Za sada nema podataka o prethodnim ili budućim intervjuima."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Trenutno nema oglasa za posao. Proveri ponovo kasnije."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Moja karijera",
            "Subtitle": "Izaberi intervju da vidiš procenu i svoje mogućnosti.",
            "MostRecentInterview": "Najskoriji intervju",
            "ToDo": "Za uraditi",
            "NoOngoingInterviews_Title": "Još nema novih pozivnica za intervju.",
            "NoOngoingInterviews_Subtitle": "Novi Hubert intervjui će se pojaviti ovde kada ih regruteri zakažu.",
            "NoRecentInterviews_Title": "Nema prethodnih intervjua.",
            "NoRecentInterviews_Subtitle": "Kada dobiješ poziv za intervju, pojaviće se ovde.",
            "ButtonText_StartInterview": "Idi na intervju",
            "ButtonText_NotScored": "Rezultati uskoro",
            "ButtonText_Details": "Detalji"
        },
        "LearnWithHubert": {
            "Title": "Uči uz Hubert",
            "Subtitle": "Dobij savete kako da unaprediš veštine za intervju i radni učinak.",
            "PickedForMe": "Najnoviji članci",
            "ButtonText_SeeAllArticles": "Pogledaj sve članke"
        },
        "HubertTip": {
            "Title": "Hubert savet",
            "Subtitle": "Završi intervjue brže",
            "Description": "Prijavljuješ se za novu poziciju sličnu onoj za koju si već ranije završio Hubert intervju? Možeš ponovo da iskoristiš odgovore iz prethodnog intervjua i uštediš vreme.",
            "ButtonText_ReadMoreTips": "Pročitaj još saveta"
        },
        "NewCandidateModalPopup": {
            "Title": "Sve je spremno!",
            "DescriptionLine1": "Tvoj nalog je sada spreman.",
            "DescriptionLine2": "Upravljaj intervjuima i profilom. Pogledaj rezultate, dobij povratne informacije i saznaj više o tome kako da uspešno radiš intervjue.",
            "ButtonText_LetsGo": "Krenimo"
        },
        "InterviewCompletedModal": {
            "Title": "Odličan posao!",
            "Subtitle": "Intervju je završen.",
            "Description": "Regruteri će pregledati sve prijave i javiti ti se imejlom ili telefonom čim budu imali novosti.",
            "ButtonText_Continue": "Nastavi"
        },
        "LatestJobPostings": {
            "Title": "Najnoviji oglasi za posao",
            "Subtitle": "Istraži druge ponude Hubert partnera koje su nedavno objavljene."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Moji intervjui",
        "MyInterviewsSection_Subtitle": "Izaberi intervju da vidiš procenu i svoje poslovne prilike.",
        "MyInterviewsSection_ToDo": "Za uraditi"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Pogledaj sve intervjue",
        "InterviewNotFound_Title": "Intervju nije dostupan",
        "InterviewNotFound_Description": "Pokušavaš da pristupiš detaljima intervjua koji nije povezan sa tvojim nalogom.",
        "ButtonText_GoToAllInterviews": "Idi na Moje intervjue",
        "InterviewDetails": {
            "Title": "Detalji intervjua",
            "ForRole": "Za poziciju",
            "InterviewCompletedOn": "Intervju je završen {{date}} u {{time}}"
        },
        "MyResult": {
            "Title": "Moj rezultat",
            "Subtitle": "Procenjena usklađenost",
            "ButtonText_LearnMore": "Saznaj kako se procenjuju tvoji odgovori",
            "GotPotential_Title": "Jak potencijal, ali nedostaje jedan uslov",
            "GotPotential_Description": "Tvoji odgovori pokazuju da imaš jak potencijal za ovu vrstu pozicije. Ipak, na osnovu ovog intervjua, moguće je da ne ispunjavaš jednu ili više obaveznih kvalifikacija za ovaj konkretan posao. To može uticati na naredne korake, u zavisnosti od potreba regrutera i ukupnog broja kandidata. Ako ne dobiješ poziv za sledeći krug, to ne znači da nemaš potencijal kao kandidat. Često se radi samo o tome da se traži vrlo precizno poklapanje sa konkretnim zahtevima pozicije. U nastavku pogledaj druge prilike i savete za napredak.",
            "GotPotential_DescriptionSecondary": "Hubertova procena služi kao smernica. Konačnu odluku donosi regruter, a na ishod mogu uticati i drugi faktori, poput broja kandidata.",
            "GreatMatch_Title": "Odlično uklapanje",
            "GreatMatch_Description": "Tvoji odgovori su se dobro poklopili sa onim što regruteri obično traže za ovu poziciju, a ujedno ispunjavaš i uslove posla. Odličan posao. Regruter će pregledati sve kandidate i odlučiti o narednim koracima.",
            "GreatMatch_DescriptionSecondary": "Hubertova procena služi kao smernica. Konačnu odluku donosi regruter, a na ishod mogu uticati i drugi faktori, poput broja kandidata. Ako ne dobiješ poziv za sledeći krug, to ne znači da nemaš potencijal kao kandidat. Često se radi samo o tome da se traži vrlo precizno poklapanje sa konkretnim zahtevima pozicije. U nastavku pogledaj druge prilike i savete za napredak.",
            "OkMatch_Title": "Ispunjavaš uslove, pojačaj utisak",
            "OkMatch_Description": "Ispunjavaš uslove za posao. Da bi ostavio još jači utisak, tvoji odgovori mogli bi da budu jasniji i konkretniji u odnosu na ono što regruteri obično viđaju za ovu poziciju. U nastavku pogledaj svoje odgovore i vidi gde bi konkretan primer ili jasan ishod mogli da poboljšaju rezultat.",
            "OkMatch_DescriptionSecondary": "Hubertova procena služi kao smernica. Konačnu odluku donosi regruter, a na ishod mogu uticati i drugi faktori, poput broja kandidata.",
            "NotClearMatch_Title": "Možda još nije najbolje poklapanje",
            "NotClearMatch_Description": "Na osnovu ovog intervjua, tvoji odgovori se možda manje poklapaju sa onim što regruter traži za ovu poziciju ili možda ne ispunjavaš jedan ili više uslova. Ako želiš da poboljšaš rezultat, kreni od pitanja u nastavku. Male promene, više konkretnosti i jasni ishodi mogu sledeći put napraviti veliku razliku.",
            "NotClearMatch_DescriptionSecondary": "Hubertova procena služi kao smernica. Konačnu odluku donosi regruter, a na ishod mogu uticati i drugi faktori, poput broja kandidata."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Profesionalno iskustvo, motivacija i kompetencije",
            "QualifyingRequirements": "Kvalifikacioni uslovi za ovu konkretnu poziciju",
            "NotQualified_Title": "Ima prostora za napredak",
            "NotQualified_Description": "Tvoji odgovori su možda bili manje konkretni ili manje usmereni na rezultat nego što regruter očekuje za ovu poziciju. U nastavku pogledaj gde bi konkretan primer, jasne aktivnosti ili konkretan rezultat mogli da ojačaju tvoj odgovor.",
            "GreatResults_Title": "Jaki odgovori",
            "GreatResults_Description": "Tvoji odgovori pokazuju da si dobar kandidat za ovu vrstu pozicije i da jasno komuniciraš. Ako postoji pitanje koje može da se unapredi, biće označeno u nastavku.",
            "MeetingRequirements_Title": "Ispunjeni uslovi",
            "MeetingRequirements_Description": "Tvoji odgovori pokazuju da ispunjavaš kvalifikacione uslove postavljene za ovaj posao. To je dobra osnova.",
            "NotAllExpectationsMet_Title": "Nedostaje jedan ili više uslova",
            "NotAllExpectationsMet_Description": "Na osnovu tvojih odgovora, moguće je da ne ispunjavaš jedan ili više kvalifikacionih uslova za ovu konkretnu poziciju, kao što su sertifikati, dozvole, nivo obrazovanja ili godine iskustva.",
            "ButtonText_FindOutPossibleReasons": "Pogledaj detalje"
        },
        "ScriptFromInterview": {
            "Title": "Pročitaj ceo intervju",
            "ButtonText_SeeWholeTranscript": "Pročitaj intervju",
            "ButtonText_DeleteInterview": "Obriši intervju",
            "Loading_Title": "Učitavanje...",
            "Loading_Subtitle": "Sačekaj dok učitamo transkript intervjua."
        },
        "HowToImproveAtInterviews": {
            "Title": "Kako da unaprediš nastup na intervjuima",
            "Subtitle_Questions": "Evo nekoliko pitanja kod kojih bi tvoj odgovor mogao da bude bolji.",
            "Subtitle_NoQuestions": "Nijedan konkretan odgovor nije označen. Evo najboljih načina da ostaviš jači utisak za ovu poziciju.",
            "GreatMatch_Questions_Description": "Čak i kada se odlično uklapaš, neki odgovori i dalje mogu da budu jači. Ako smo ih prepoznali, naći ćeš ih ispod. Prati smernice pre svakog pitanja. Kada opisuješ situaciju, uključi šta se desilo, šta si uradio i kakav je bio rezultat. Odgovor poput „OK“ ne pomaže kada tražimo da obrazložiš. U isto vreme, izbegavaj preduge odgovore. Ciljaj na jasne i konkretne opise, kao na razgovoru uživo.",
            "GreatMatch_NoQuestions_Description": "Na pitanja si odgovorio vrlo dobro. Odličan posao.",
            "OkMatch_Questions_Description": "U nastavku ćeš naći pitanja kod kojih bi tvoj odgovor mogao da bude bolji. Prati smernice pre svakog pitanja. Kada opisuješ situaciju, uključi šta se desilo, šta si uradio i kakav je bio rezultat. Odgovor poput „OK“ ne pomaže kada tražimo da obrazložiš. U isto vreme, izbegavaj preduge odgovore. Ciljaj na jasne i konkretne opise, kao na razgovoru uživo.",
            "OkMatch_NoQuestions_Description": "Tvoji odgovori su bili dobri, ali ova pozicija može biti konkurentna. To znači da i dobri odgovori ponekad završe u sredini.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Sledeći put ciljaj na jasnoću i utisak. Počni od rezultata, dodaj jedan stvaran primer i zadrži odgovor kratkim — obično 3 do 6 rečenica. Budi konkretan u tome šta si uradio, kako si to uradio i šta se promenilo zahvaljujući tome.",
            "GotPotential_Questions_Description": "Čak i ako deluje da se dobro uklapaš u ovu vrstu posla, neki odgovori i dalje mogu da budu jači. Ako smo ih prepoznali, naći ćeš ih ispod. Prati smernice pre svakog pitanja. Kada opisuješ situaciju, uključi šta se desilo, šta si uradio i kakav je bio rezultat. Odgovor poput „OK“ ne pomaže kada tražimo da obrazložiš. U isto vreme, izbegavaj preduge odgovore. Ciljaj na jasne i konkretne opise, kao na razgovoru uživo.",
            "GotPotential_NoQuestions_Description": "Nismo pronašli odgovore koji zahtevaju veće unapređenje kada je reč o profesionalnim kompetencijama i motivaciji. Deluje da si na te teme odgovorio dobro.",
            "NotClearMatch_Questions_Description": "U nastavku ćeš naći pitanja kod kojih bi tvoj odgovor mogao da bude bolji. Prati smernice pre svakog pitanja. Kada opisuješ situaciju, uključi šta se desilo, šta si uradio i kakav je bio rezultat. Odgovor poput „OK“ ne pomaže kada tražimo da obrazložiš. U isto vreme, izbegavaj preduge odgovore. Ciljaj na jasne i konkretne opise, kao na razgovoru uživo.",
            "NotClearMatch_NoQuestions_Description": "Nismo pronašli nijedan „loš“ odgovor. Više se radi o ukupnom poklapanju sa onim što je ovoj poziciji potrebno. Ako je konkurencija jaka, i male razlike mogu biti važne.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Na sledećem intervjuu fokusiraj se na konkretnost. Izaberi po jedan primer za svako pitanje, objasni svoje postupke i podeli ishod. Kratko i konkretno je najčešće bolje od dugog i opšteg.",
            "Alert_WantMoreAdvice": "Želiš još saveta za uspeh na Hubert intervjuu?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Pogledaj naš opšti članak sa savetima"
        },
        "SimilarOffers": {
            "Title": "Slične ponude"
        },
        "HowHubertScoresInterviews": {
            "Title": "Kako Hubert procenjuje intervjue?",
            "Description": "U nastavku je kratko objašnjenje kako Hubert procenjuje odgovore na intervjuu. Dodali smo i odeljak „Proces zapošljavanja“ da bismo objasnili kako izgledaju naredni koraci nakon Hubert intervjua.",
            "Tabs_PossibleOutcomes": "Mogući ishodi",
            "Tabs_RecruitmentProcess": "Proces zapošljavanja",
            "AssessedMatch_Title": "Procenjena usklađenost",
            "AssessedMatch_Description": "Hubert procenjuje kako tvoji odgovori ukupno deluju u odnosu na ono što regruteri obično traže za ovu poziciju. Zajedno sa zahtevima same pozicije, videćeš jedan od ishoda u nastavku.",
            "AssessedMatch_DescriptionSecondary": "Hubertova procena služi kao smernica. Konačnu odluku donosi regruter, a na ishod mogu uticati i drugi faktori, poput broja kandidata.",
            "GreatMatch_Title": "Odlično uklapanje",
            "GreatMatch_Description": "Tvoji odgovori su se dobro poklopili sa onim što regruteri obično traže za ovu poziciju, a ujedno ispunjavaš i uslove posla. Odličan posao. Regruter će pregledati sve kandidate i odlučiti o narednim koracima.",
            "GotPotential_Title": "Jak potencijal, ali nedostaje jedan uslov",
            "GotPotential_Description": "Tvoji odgovori pokazuju da imaš jak potencijal za ovu vrstu pozicije. Ipak, na osnovu ovog intervjua, moguće je da ne ispunjavaš jednu ili više obaveznih kvalifikacija za ovaj konkretan posao. To može uticati na naredne korake, u zavisnosti od potreba regrutera i ukupnog broja kandidata.",
            "OkMatch_Title": "Ispunjavaš uslove, pojačaj utisak",
            "OkMatch_Description": "Ispunjavaš uslove za posao. Da bi ostavio jači utisak, tvoji odgovori možda treba da budu jasniji i konkretniji u odnosu na ono što regruteri obično viđaju za ovu poziciju. Iskoristi povratne informacije iz intervjua da za buduće prilike dodatno ojačaš svoje primere i ishode.",
            "NotClearMatch_Title": "Možda još nije najbolje poklapanje",
            "NotClearMatch_Description": "Na osnovu ovog intervjua, tvoji odgovori se možda manje poklapaju sa onim što regruter traži za ovu poziciju, a moguće je i da ne ispunjavaš jedan ili više uslova. Pregledaj svoje odgovore i vidi gde možeš da dodaš više jasnoće, primera i konkretnih ishoda.",
            "ProfessionalExperiences_Title": "Profesionalno iskustvo, motivacija i kompetencije",
            "ProfessionalExperiences_Description": "To su pitanja o tvom prethodnom iskustvu, motivaciji za posao i kompetencijama koje su relevantne za ovu poziciju. Regruteri odlučuju koja će pitanja biti korišćena u intervjuu za konkretan posao.",
            "GreatResults_Title": "Uverljivi odgovori",
            "GreatResults_Description": "Tvoji odgovori pokazuju da si dobar kandidat za ovu vrstu pozicije i da jasno komuniciraš. Ako postoji pitanje koje može da se unapredi, biće označeno u tvom intervjuu.",
            "NotQualified_Title": "Ima prostora za napredak",
            "NotQualified_Description": "Tvoji odgovori su možda bili manje konkretni ili manje usmereni na rezultat nego što regruter očekuje za ovu poziciju. Potraži označena mesta na kojima bi konkretan primer, tvoje aktivnosti ili jasan rezultat mogli da ojačaju odgovor.",
            "QualifyingRequirements_Title": "Osnovni ili kvalifikacioni uslovi za ovu konkretnu poziciju",
            "QualifyingRequirements_Description": "To su pitanja koja je regruter postavio kao kvalifikacione uslove za posao. Na primer, obavezan sertifikat, vozačka dozvola ili određeni nivo relevantnog iskustva.",
            "MeetingRequirements_Title": "Ispunjeni uslovi",
            "MeetingRequirements_Description": "Tvoji odgovori pokazuju da ispunjavaš kvalifikacione uslove koje je regruter postavio za ovaj posao. To je dobra osnova.",
            "NotAllExpectationsMet_Title": "Nedostaje jedan ili više uslova",
            "NotAllExpectationsMet_Description": "Na osnovu tvojih odgovora, moguće je da ne ispunjavaš jedan ili više kvalifikacionih uslova za ovu konkretnu poziciju, kao što su sertifikati, dozvole, nivo obrazovanja ili godine iskustva.",
            "RecruitmentProcess_Title": "Proces zapošljavanja",
            "RecruitmentProcess_Description": "Hubert se najčešće koristi kao prvi korak u procesu zapošljavanja kada postoji veliki broj kandidata. Omogućava svakome da završi intervju i predstavi se svojim rečima. Pošto su pitanja ista za sve kandidate koji se prijavljuju za isti posao, proces je ujednačeniji. Hubert takođe ne koristi podatke kao što su pol, godine, etničko poreklo, veroispovest ili izgled, što pomaže da se smanji rizik od nesvesne pristrasnosti.",
            "EventOne_Title": "Intervju obavljaš sa Hubertom",
            "EventOne_Description": "Intervju sa Hubertom možeš da obaviš kada i gde ti najviše odgovara. Nema vremenskih ograničenja, a u svakom trenutku možeš da napraviš pauzu i nastaviš tamo gde si stao.",
            "EventTwo_Title": "Tvoj intervju se procenjuje",
            "EventTwo_Description": "Hubert procenjuje tvoje odgovore uz pomoć savremene tehnologije. Čim procena bude završena, rezultati će biti vidljivi ovde u okviru My Hubert-a, kao i regruteru u njegovom sistemu za prijave kandidata.",
            "EventThree_Title": "Regruter bira kandidate za sledeće korake",
            "EventThree_Description": "U svom sistemu za prijave kandidata regruteri mogu da vide kada je dostupan novi rezultat Hubert intervjua. Zatim mogu da pregledaju tvoje odgovore i Hubertovu procenu. Na osnovu Hubertove procene, koja služi kao smernica, i sopstvene procene, regruteri odlučuju da li ćeš dobiti poziv za sledeći krug. To može biti telefonski razgovor, test ili završni intervju. U nekim slučajevima regruteri mogu sačekati pre narednih koraka. Ako se drugi kandidati bolje uklapaju, tvoja prijava može biti odbijena.",
            "ButtonText_Close": "Zatvori"
        }
    },
    "MyProfile": {
        "Title": "Moj profil",
        "MyDetails": {
            "Title": "Moji podaci",
            "Label_FirstName": "Ime",
            "Label_LastName": "Prezime",
            "Label_Email": "Imejl",
            "Label_PhoneNumber": "Broj telefona",
            "ButtonText_UpdateDetails": "Ažuriraj podatke",
            "Error_FirstName_Required": "Ime je obavezno.",
            "Error_LastName_Required": "Prezime je obavezno.",
            "Error_Email_Required": "Imejl je obavezan.",
            "Error_Email_Invalid": "Unesi ispravnu imejl adresu.",
            "Error_PhoneNumber_Invalid": "Broj telefona nije ispravan.",
            "Success_Details_Updated": "Profil je ažuriran."
        },
        "ChangePassword": {
            "Title": "Promeni lozinku",
            "Set_Password_Title": "Kreiraj lozinku",
            "Label_CurrentPassword": "Trenutna lozinka",
            "Label_NewPassword": "Nova lozinka",
            "Label_RepeatNewPassword": "Ponovi novu lozinku",
            "Alert_SignInAgain": "Molimo te da se ponovo prijaviš kako bi postavio lozinku.",
            "ButtonText_UpdatePassword": "Ažuriraj lozinku",
            "ButtonText_SetPassword": "Postavi lozinku",
            "ButtonText_SignInAgain": "Prijavi se ponovo",
            "Error_CurrentPassword_Required": "Trenutna lozinka je obavezna.",
            "Error_CurrentPassword_DoesntMatch": "Lozinka se ne poklapa sa trenutnom lozinkom.",
            "Error_NewPassword_Required": "Nova lozinka je obavezna.",
            "Error_NewPassword_6_Characters": "Nova lozinka mora da ima najmanje 6 karaktera.",
            "Error_RepeatNewPassword_Required": "Potvrda nove lozinke je obavezna.",
            "Error_RepeatNewPassword_DoesntMatch": "Lozinka se ne poklapa sa novom lozinkom.",
            "Success_Password_Changed": "Lozinka je ažurirana.",
            "Error_Invalid_CurrentPassword": "Trenutna lozinka nije ispravna."
        },
        "NotificationPreferences": {
            "Title": "Podešavanja obaveštenja",
            "Label_ReceiveUpdatesToggle": "Želim da primam Hubert novosti.",
            "Label_ReceiveUpdatesToggleHelpText": "Dobijaćeš vodiče za karijeru, savete za intervju i još mnogo toga."
        },
        "AccountRemoval": {
            "Title": "Brisanje naloga",
            "ButtonText_RemoveMyAccount": "Obriši moj nalog"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Zdravo",
        "Subtitle": "Hvala na prijavi! Sledeći korak je intervju sa našom digitalnom asistentkinjom Hubert.",
        "TipBox_Title": "Evo nekoliko saveta koji ti mogu pomoći da ostaviš dobar utisak.",
        "TipBox_Tip1": "Obavi intervju na mirnom mestu gde možeš da se koncentrišeš i udobno kucaš.",
        "TipBox_Tip2": "Odgovaraj sa računara i tastature (osim ako ti je sasvim prijatno da duže pišeš na telefonu).",
        "TipBox_Tip3": "Budi što konkretniji i detaljniji u odgovorima. Hubert i regruteri žele da te zaista upoznaju.",
        "TipBox_Tip4": "Uzmi vremena koliko ti je potrebno. Nema vremenskog ograničenja.",
        "TipBox_Tip5": "U svakom trenutku možeš da napraviš pauzu i nastaviš tamo gde si stao.",
        "TipBox_Tip6": "Budi svoj i pristupi Hubert intervjuu jednako ozbiljno kao razgovoru uživo.",
        "CheckAdviceArticle_Text1": "Ako želiš još saveta kako da uspeš na intervjuu, pogledaj ovaj",
        "CheckAdviceArticle_Text2": "članak",
        "CheckAdviceArticle_Text3": "sa odličnim savetima.",
        "ReadyToGetStarted": "Da li je sve spremno za početak?",
        "ORSeparator_Text": "Ili",
        "ButtonText_StartInterviewNow": "Započni intervju odmah",
        "ButtonText_SetReminder": "Sada mi ne odgovara, podseti me",
        "PrivacyPolicyText": "Pritiskom na „Započni intervju“ prihvataš",
        "PrivacyPolicyLink": " Politiku privatnosti i Uslove korišćenja"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Odličan posao!",
        "CompletedAlert_Subtitle": "Intervju je završen.",
        "CompletedAlert_Description": "Regruteri će pregledati sve prijave i javiti ti se imejlom ili telefonom čim budu imali novosti.",
        "InterviewNotCompleted": "Ovaj intervju nije završen."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centar za pomoć",
            "Subtitle": "Pronađi odgovore na najčešća pitanja o Hubertu.",
            "Label_Search": "pretraži često postavljana pitanja",
            "ButtonText_Search": "Pretraži"
        },
        "FAQSection": {
            "Tabs_All": "Sve",
            "Tabs_AboutHubertInterview": "O Hubert intervjuu",
            "Tabs_TechnicalSupport": "Tehnička podrška"
        },
        "StillHaveQuestion": {
            "Title": "Imaš još neko pitanje?",
            "Description": "Rado ćemo pomoći.",
            "DropUsAEmail": "Piši nam na hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Mogu li intervju da obavim telefonskim pozivom?",
                    "a": "Hubert je trenutno dostupan samo putem četa. Ako imaš zdravstveno stanje koje te sprečava da obaviš intervju, obrati se direktno kompaniji koja zapošljava. Hubert je zadužen samo za čet intervju."
                },
                {
                    "q": "Mogu li intervju da radim na drugom jeziku?",
                    "a": "Kod nekih intervjua postoji mogućnost izbora jezika na početku. Ako ta opcija ne postoji, najverovatnije je razumevanje jezika intervjua uslov za poziciju. Za dodatna pitanja obrati se kompaniji koja sprovodi selekciju."
                },
                {
                    "q": "Da li kratki odgovori utiču negativno na rezultat?",
                    "a": "Ne, nećeš, sve dok odgovoriš na pitanje na odgovarajući način. Ne postoji minimalna dužina odgovora, ali detalji često pomažu."
                },
                {
                    "q": "Mogu li da ponovo iskoristim odgovore iz drugog intervjua sa Hubertom?",
                    "a": "Da, možeš ponovo da iskoristiš prethodne odgovore ako si prijavljen u My Hubert i prijavljuješ se za sličnu poziciju."
                },
                {
                    "q": "Da li će stvarna osoba pročitati moj intervju?",
                    "a": "Da, od naših klijenata se traži da ručno pregledaju intervjue."
                },
                {
                    "q": "Završio sam intervju, šta se sada dešava?",
                    "a": "Nakon završetka intervjua, rezultati se šalju regruteru u njegov sistem za prijave kandidata. Regruteri zatim mogu da pregledaju tvoje odgovore i Hubertovu procenu. Na osnovu Hubertove procene, koja služi kao smernica, i sopstvene procene, regruteri odlučuju da li ćeš dobiti poziv za sledeći korak. To može biti telefonski razgovor, test ili završni intervju."
                },
                {
                    "q": "Imam pitanje o narednim koracima u procesu, kome da se obratim?",
                    "a": "Obrati se kompaniji kod koje si konkurisao za posao."
                },
                {
                    "q": "Kako obezbeđujete da ne uvodite pristrasnost u proces zapošljavanja?",
                    "a": "Smanjenje pristrasnosti nam je veoma važno. Kao sistem, Hubert je dosledniji u proceni nego što čovek može da bude. Naši modeli se treniraju uz pomoć velikog broja stručnih procenjivača različitog porekla. Pored toga, Hubert ne koristi podatke kao što su pol, godine, etničko poreklo, veroispovest ili izgled, koji su česti izvori pristrasnosti u tradicionalnim ručnim intervjuima za posao."
                },
                {
                    "q": "Mogu li da me intervjuiše čovek umesto Huberta?",
                    "a": "Obrati se kompaniji kod koje si konkurisao i raspitaj se o toj mogućnosti."
                },
                {
                    "q": "Da li je Hubert stvarna osoba?",
                    "a": "Ne, Hubert je računarski sistem za intervjuisanje i analizu."
                },
                {
                    "q": "Mogu li kasnije da izmenim svoje odgovore?",
                    "a": "Ne, baš kao na pravom intervjuu, ne možeš ponovo da daješ odgovore nakon što ih pošalješ."
                },
                {
                    "q": "Kako da budem uspešan na Hubert intervjuu?",
                    "a": "Pažljivo pročitaj pitanja pre nego što odgovoriš. Prati uputstva. Navodi stvarne primere iz svog iskustva i budi iskren."
                },
                {
                    "q": "Potreban mi je posao, kome da se obratim?",
                    "a": "Obrati se kompaniji kod koje si konkurisao."
                },
                {
                    "q": "Završio sam intervju, ali mi se niko nije javio. Šta da radim?",
                    "a": "Regruteri odlučuju o narednim koracima na osnovu Hubertove procene i sopstvene procene. To može biti telefonski razgovor, test ili završni intervju. Ako se drugi kandidati bolje uklapaju, mogu odbiti tvoju prijavu. Možda želiš da kontaktiraš regrutera i proveriš status svoje prijave."
                },
                {
                    "q": "Imam mnogo iskustva, ali nisam dobio posao. Zašto?",
                    "a": "Konkurencija za posao može biti velika, sa mnogo kvalifikovanih kandidata. Ako je tvoja prijava odbijena, možeš kontaktirati kompaniju i pitati za razlog. U okviru My Hubert-a takođe možeš pogledati povratne informacije na osnovu svojih odgovora sa intervjua i videti druge opcije za posao."
                },
                {
                    "q": "Koliko traje intervju?",
                    "a": "Zavisi od broja pitanja koje je postavio regruter. Očekuj između 10 i 25 minuta. Nemoj žuriti. Možeš da napraviš pauzu i nastaviš kasnije ako ti je potrebno."
                },
                {
                    "q": "Gde mogu da pročitam kako se obrađuju moji podaci?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Zašto ne mogu da vidim svoje prethodne Hubert intervjue?",
                    "a": "Proveri da li si koristio istu imejl adresu za prijavu na posao i za nalog na My Hubertu. To važi i ako koristiš Google prijavu; Google imejl mora da se poklapa sa imejl adresom koju si koristio pri prijavi za posao. Pokušaj da kreiraš nalog sa imejl adresom koju si koristio pri prijavi."
                },
                {
                    "q": "Zašto nisam dobio imejl za intervju?",
                    "a": "Proveri folder neželjene pošte (Spam). Možeš i da dodaš hubert@hubert.ai u kontakte. Alternativno, kreiraj nalog na My Hubertu koristeći imejl adresu sa prijave i tamo pronađi link za intervju."
                },
                {
                    "q": "Ne mogu da pronađem link za intervju u imejlu.",
                    "a": "Proveri folder neželjene pošte (Spam). Alternativno, kreiraj nalog na My Hubertu koristeći imejl adresu sa prijave i idi na „Moji intervjui“ da pronađeš link."
                },
                {
                    "q": "Da li intervju radi na mobilnim uređajima?",
                    "a": "Da, radi. Ipak, ako ti je prijatnije da kucaš na računaru, preporučujemo da koristiš njega."
                },
                {
                    "q": "Intervju ne radi, šta da radim?",
                    "a": "Žao nam je zbog toga. Piši nam na hubert@hubert.ai i pomoći ćemo ti."
                },
                {
                    "q": "Želim da obrišem ceo svoj nalog na My Hubertu. Šta treba da uradim?",
                    "a": "Pošalji nam imejl na hubert@hubert.ai i pomoći ćemo ti."
                },
                {
                    "q": "Intervju je prekinut, kako da se vratim?",
                    "a": "Klikni na link iz pozivnog imejla da nastaviš tamo gde si stao ili se prijavi na My Hubert i izaberi intervju u odeljku „Moji intervjui“."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Uči uz Hubert",
            "Subtitle": "Saznaj kako da povećaš svoje šanse u procesu zapošljavanja i napreduješ na poslu.",
            "Label_Search": "pretraži vodiče za intervju i karijeru",
            "ButtonText_Search": "Pretraži"
        },
        "TabSelector": {
            "MyFeed": "Moj feed",
            "InterviewGuides": "Vodiči za intervju",
            "CareerGuides": "Vodiči za karijeru"
        },
        "NewestOnTheFeed": "Najnovije u feed-u",
        "PickedForMe": "Najnoviji članci",
        "InterviewGuides": "Vodiči za intervju",
        "CareerGuides": "Vodiči za karijeru"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Nazad na sve članke"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Resetuj lozinku",
        "ResetLinkAlert_Subtitle": "Klikni na link za reset lozinke koji smo poslali na tvoj imejl da postaviš novu lozinku i prijaviš se na nalog.",
        "PasswordNotSetAlert_Message": "Lozinka nije postavljena, prijavi se pomoću ",
        "ResetYourPassword": {
            "MainTitle": "Pogledaj rezultate svog Hubert intervjua",
            "Subtitle": "Prijavi se da vidiš rezultate, dobiješ povratne informacije, pročitaš savete i još mnogo toga.",
            "FormSectionTitle": "Resetuj lozinku",
            "Label_NewPassword": "Nova lozinka",
            "Label_ConfirmNewPassword": "Potvrdi novu lozinku",
            "Error_NewPassword_Required": "Molimo te da uneseš novu lozinku.",
            "Error_Password_6_Characters": "Nova lozinka mora da ima najmanje 6 karaktera.",
            "Error_ConfirmNewPassword_Required": "Moraš da potvrdiš novu lozinku.",
            "Error_ConfirmNewPassword_NotMatch": "Lozinka se ne poklapa sa novom lozinkom.",
            "Error_MalformedResetUrl": "Bezbednosni kod nije ispravan. Pokušaj ponovo.",
            "Error_ResetPasswordFailed": "Došlo je do problema pri resetovanju lozinke. Pokušaj ponovo.",
            "Error_WeakPassword": "Lozinka mora da sadrži najmanje 6 karaktera.",
            "Error_InvalidCode_Title": "Zahtev za reset lozinke je istekao ili nije ispravan.",
            "Error_InvalidCode_Subtitle": "Molimo te da ponovo pokušaš da resetuješ lozinku.",
            "ButtonText_SetNewPassword": "Postavi novu lozinku i prijavi se",
            "ButtonText_RememberYourPassword": "Sećaš se lozinke?",
            "ButtonText_SignInInstead": "Prijavi se umesto toga"
        }
    },
    "PageNotFound": {
        "Title": "Stranica nije pronađena",
        "Description": "Izgleda da ne možemo da pronađemo stranicu koju tražiš.",
        "ButtonText_GoToDashboard": "Idi na početnu",
        "ButtonText_GoToLogin": "Idi na prijavu"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Ponovna upotreba odgovora još nije dostupna za ovaj intervju. Očekujemo da ova opcija uskoro bude dostupna, ali intervju i dalje možeš da uradiš sada.",
        "DescriptionLine2": "Nastavi na intervju klikom na dugme ispod.",
        "ButtonText_TakeMeToTheInterview": "Vodi me na intervju"
    },
    "UnsubscribeFromEmails": {
        "Title": "Da li si siguran da želiš ovo?",
        "Subtitle": "Prestaćeš da primaš naše imejlove u vezi sa ovim poslom:",
        "SelectTheReason": "Izaberi razlog među opcijama ispod.",
        "ReasonText1": "Pronašao sam drugi posao.",
        "ReasonText2": "Ovaj posao me više ne zanima.",
        "ReasonText3": "Drugo",
        "ButtonText_Unsubscribe": "Odjavi se sa obaveštenja za ovaj posao",
        "Placeholder_YourReason": "Tvoj razlog",
        "Success_Title": "Uspešno si odjavljen sa imejlova za ovaj posao.",
        "Loading": "Učitavanje...",
        "Error_YourReason_Required": "Molimo te da uneseš razlog.",
        "Error_ServerIssue": "Odjava nije uspela zbog greške na serveru."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Pokušaj ponovo"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidat nije pronađen",
        "CandidateNotFoundDesc": "Nismo uspeli da pronađemo detalje intervjua koje tražiš.",
        "InterviewEnded": "Intervju je završen",
        "InterviewEndedDesc1": "Ova sesija intervjua je završena ili više nije dostupna.",
        "InterviewEndedDesc2": "Hvala ti na vremenu. Ako imaš pitanja, obrati se timu za zapošljavanje.",
        "ReadyTitle": "Sve je spremno za intervju, {{firstName}}?",
        "InvitationDesc": "Hubert te, u ime kompanije {{companyName}}, poziva na intervju putem četa. Za završetak je potrebno oko 1–2 minuta.",
        "Button_StartChat": "Započni čet intervju",
        "CancelNotice": "Pokretanjem ovde otkazuješ zakazani poziv za ovu poziciju.",
        "PreferNotToContinue": "Ne želiš da nastaviš?",
        "DeclineLabel": "Ova pozicija me ne zanima. Molim vas da me više ne zovete i ne šaljete poruke u vezi sa njom.",
        "Button_ConfirmAndDecline": "Potvrdi i odustani",
        "Processing": "Obrađujemo...",
        "Toast_DeclineSuccess": "Intervju je odbijen.",
        "Toast_CancelVoiceInfo": "Poziv je otkazan. Funkcija uskoro stiže.",
        "Toast_CancelError": "Nismo uspeli da otkažemo intervju. Pokušaj ponovo.",
        "Footer_WithdrawConsent": "Saglasnost možeš povući u bilo kom trenutku. Saznaj više u politici privatnosti kompanije ",
        "Footer_PrivacyPolicySuffix": "",
        "Footer_And": " i ",
        "Footer_HubertPrivacyLink": "Hubertovoj politici privatnosti i uslovima korišćenja",
        "Chat_InterviewWith": "Intervju sa kompanijom {{companyName}}",
        "Chat_StatusConnected": "Povezano",
        "Chat_StatusError": "Greška",
        "Chat_StatusDisconnected": "Veza je prekinuta",
        "Chat_StatusConnecting": "Povezivanje...",
        "Chat_ReadyToStart": "Da li si spreman da započneš intervju?",
        "Chat_ButtonStart": "Započni intervju",
        "Chat_SayHello": "Napiši „Zdravo“ da započneš razgovor.",
        "Chat_EmptyState": "Pošalji poruku da započneš intervju.",
        "Chat_SelectLanguage": "Izaberi željeni jezik",
        "Chat_Placeholder": "Upiši poruku...",
        "Chat_ButtonSend": "Pošalji",
        "Chat_ButtonBack": "Nazad",
        "LoadingCandidateDetails": "Učitavamo podatke o kandidatu...",
        "FetchingCandidateDetails": "Preuzimamo podatke o kandidatu...",
        "Chat_StatusReady": "Čeka se povezivanje...",
        "Chat_ForbiddenError": "Ovaj čet intervju više nije dostupan.",
        "Chat_GeneralError": "Nije uspelo pokretanje četa. Pokušaj ponovo kasnije.",
        "Chat_SelectUiLanguage": "Jezik interfejsa",
        "Chat_InterviewTitle": "Razgovor za posao"
    }
}
